/** ConeTwistJoint3D property surface. A span stays `undefined` when unauthored, so the consumer applies Godot's default. */
/** `params[PARAM_SWING_SPAN] = Math::PI * 0.25` in cone_twist_joint_3d.cpp:90, in radians. */
export const DEFAULT_SWING_SPAN = Math.PI / 4;
/** `params[PARAM_TWIST_SPAN] = Math::PI` in cone_twist_joint_3d.cpp:91, in radians. */
export const DEFAULT_TWIST_SPAN = Math.PI;
//# sourceMappingURL=types.js.map